module.exports = __webpack_public_path__ + "img/danger.9fa2a807.png";